// useTableSettings.js

const DEFAULT_CORNER_WIDTH = 80;
const DEFAULT_FIELD_WIDTH = 200;
const DEFAULT_AUTONUMBER_WIDTH = 60;
const DEFAULT_AUTOKEY_WIDTH = 90;
const DEFAULT_TIMESTAMP_FIELD_WIDTH = 250;

const MIN_COLUMN_WIDTHS = {
    open: 44,
    title: 160,
    default: 60,
};

const DEFAULT_CORNER_CHECKBOX_WIDTH = 31;
const DEFAULT_OPEN_ONLY_CORNER_WIDTH = Math.max(
    MIN_COLUMN_WIDTHS.open,
    DEFAULT_CORNER_WIDTH - DEFAULT_CORNER_CHECKBOX_WIDTH,
);

const getMinColumnWidth = (key) => (
    MIN_COLUMN_WIDTHS[key] ?? MIN_COLUMN_WIDTHS.default
);

const useTableSettings = () => ({
    defaultCornerWidth: DEFAULT_CORNER_WIDTH,
    defaultFieldWidth: DEFAULT_FIELD_WIDTH,
    defaultTimestampFieldWidth: DEFAULT_TIMESTAMP_FIELD_WIDTH,
    minColumnWidths: MIN_COLUMN_WIDTHS,
    getMinColumnWidth,
});

export {
    DEFAULT_CORNER_WIDTH,
    DEFAULT_OPEN_ONLY_CORNER_WIDTH,
    DEFAULT_FIELD_WIDTH,
    DEFAULT_AUTONUMBER_WIDTH,
    DEFAULT_AUTOKEY_WIDTH,
    DEFAULT_TIMESTAMP_FIELD_WIDTH,
    MIN_COLUMN_WIDTHS,
    getMinColumnWidth,
};

export default useTableSettings;
